import React, { useEffect, useState } from 'react';
import styles from '../../styles/Notification.module.css';
import buttonStyles from '../../styles/Buttons.module.css';


interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  okText?: string;
  cancelText?: string;
  showCancel?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  okText = 'Confirm',
  cancelText = 'Cancel',
  showCancel = true,
  onConfirm,
  onCancel
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsAnimating(true);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onConfirm();
    }, 150);
  };

  const handleCancel = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onCancel();
    }, 150);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isOpen && e.key === 'Escape') {
        handleCancel();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={`${styles.confirmModalOverlay} ${isAnimating ? styles.active : ''}`}
      onClick={handleOverlayClick}
    >
      <div className={styles.confirmModalContent}>
        <div className={styles.confirmModalHeader}>
          <h3 className={styles.confirmModalTitle}>{title}</h3>
          <button className={styles.confirmModalClose} onClick={handleCancel}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg></button>
        </div>
        <div className={styles.confirmModalBody} dangerouslySetInnerHTML={{ __html: message }} />
        <div className={styles.confirmModalFooter}>
          {showCancel && (
            <button className={`${buttonStyles.btn} ${buttonStyles.btnSecondary} `} onClick={handleCancel}>
              {cancelText}
            </button>
          )}
          <button className={`${buttonStyles.btn} ${buttonStyles.btnPrimary}`} onClick={handleConfirm}>
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
